<template>
  <div class="wrapper">
    <div>
      <div class="product-name">
        {{ translate(selectedProduct, 'name') }}
      </div>
      <div v-if="selectedProduct.requirements.date" class="date">
        {{ details[0].date | shortDate }}
      </div>
    </div>
    <div class="skiers">
      <img class="icon" :src="`/img/icons/icon-${icon}.svg`">
      {{ details.length }}
    </div>
  </div>
</template>

<script>
  import { translate } from '@/helpers/translationsHelpers.js'

  export default {
    name: "product-resume",
    computed: {
      icon: function () {
        return this.totalSkiers == 1 ? 'person' : 'people';
      },
      details() {
        return this.$store.getters['order/details']
      },
      selectedProduct() {
        return this.$store.getters['resort/selectedProduct']
      },
      language() {
        return this.$store.getters['device/language']
      }
    },
    methods: {
      translate(object, field) {
        return translate(object, field)
      }
    }
  };
</script>

<style scoped>

  .wrapper {
    @apply w-full py-2 px-5.5 flex justify-between items-center bg-white z-5 border-b-1 border-grey-border;
    top: 48px;
  }

  .product-name {
    @apply text-left text-sm text-black;
  }

  .icon {
    @apply w-5 h-5 object-contain mr-1;
  }

  .date {
    @apply text-xs text-grey-text;
  }

  .skiers {
    @apply text-sm flex items-center text-grey-text;
  }

  @screen lg {
    .wrapper {
      @apply hidden;
    }
  }

</style>
